$(document).ready(function(){
    product_description_accordion();
    footer_accordion();
   $(".spr-stars").click(function() {
    $('html,body').animate({
            scrollTop: $("#shopify-product-reviews").offset().top
        },
        'slow');
});
})



function footer_accordion(){
  if($(window).width()<750)
  {
        $('.myfooteraccordionclass').addClass('accordion');
        var existing_classes=$('.accordion').next().attr('class')+' accordion-content';
        $('.accordion').next().attr('class',existing_classes);
        $('.accordion').click(function(){
        var accr = $(this).text();
        accr = accr.replace(" ", "");
        if($(this).hasClass('active')){
           $(this).removeClass('active');
           $(this).next().removeClass('active');
        }
        else{
          $(this).addClass('active');
          $(this).next().addClass('active');
        }
        $('.accordion').each(function(){
          var acc = $(this).text();
          acc = acc.replace(" ", "");
          if(accr != acc){
            $(this).removeClass('active');
            $(this).next().removeClass('active');
          }
        });
    })
  }
}

function product_description_accordion(){
  var existing_classes=$('.product_description_accordion').next().attr('class')+' product_description_accordion-content';
    $('.product_description_accordion').next().attr('class',existing_classes);
  $('.product_description_accordion').click(function(){
    if($(this).hasClass('active')){
         $(this).removeClass('active');
         $(this).next().removeClass('active');
      }
      else{
        $(this).addClass('active');
        $(this).next().addClass('active');
      }
  })
}


 







